// extracted by mini-css-extract-plugin
export default {"container":"Dropzone_container__MCt-Q","dropzone":"Dropzone_dropzone__x-+SB","content_file":"Dropzone_content_file__iNYCF"};